import { render, staticRenderFns } from "./SellerForm.vue?vue&type=template&id=f38b12fa&"
import script from "./SellerForm.vue?vue&type=script&lang=js&"
export * from "./SellerForm.vue?vue&type=script&lang=js&"
import style0 from "./SellerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports